import React, { useEffect, useState } from "react";
import "./Consultation_Banner.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Solar_Modal from "../../common/solar-modal/Solar_Modal";
import { useNavigate } from "react-router-dom";

const Consultation_Banner = () => {
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  
  const handleSubmit = () => {
    
    setShowModal(true);
    
  };

  return (
    <>
      <section className="Consultation_Banner">
        <div className="container">
          <div className="Consultation_Banner_holder">
            <div className="Consultation_Banner_text_div">
              <p className="Consultation_Banner_title">Get Your</p>

              <h5 className="Consultation_Banner_subtitle">
                Free Solar Consultation Today
              </h5>

              <p className="Consultation_Banner_text">
                Book a free consultation and let our experts guide you through
                savings, installation, and benefits.. Receive a personalized solar
                plan designed to maximize your energy savings.
              </p>
            </div>

            <div
              className="Consultation_Banner_btn_holder"
              onClick={handleSubmit}
            >
              <Common_Btn text={"Get Free Consultation"} />
            </div>
          </div>
        </div>

        <Solar_Modal show={showModal} handleClose={() => setShowModal(false)} />
      </section>
    </>
  );
};

export default Consultation_Banner;
